import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

export const TRACKING_EVENT = 'tracking:changed';
export const notifyTrackingChanged = () => window.dispatchEvent(new Event(TRACKING_EVENT));

const EMPTY = { items: [], open_count: 0, tracked_prediction_ids: [] };

export function useMyTracking(pollMs = 20000) {
    const [data, setData] = useState(null);

    const load = useCallback(async () => {
        try {
            const { data: res } = await apiClient.get('/tracking/mine');
            setData(res || EMPTY);
        } catch (e) {
            logger.warn('tracking/mine failed', e);
            setData((d) => d || EMPTY);
        }
    }, []);

    useEffect(() => {
        load();
        const id = setInterval(load, pollMs);
        window.addEventListener(TRACKING_EVENT, load);
        return () => {
            clearInterval(id);
            window.removeEventListener(TRACKING_EVENT, load);
        };
    }, [load, pollMs]);

    return { data, reload: load };
}
